// import 'react-app-polyfill/stable';
import './wydr';

import { StrictMode, Suspense } from 'react';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';

import BrandContextProvider from 'components/context/BrandContext/BrandContext';
import App from 'components/root/App/App';
import GeneralError from 'components/root/GeneralError/GeneralError';
import LoaderOverlay from 'components/UI/molecules/LoaderOverlay/LoaderOverlay';
import axiosSetup from 'config/axios';
import queryClient from 'config/queryClient';
import { SHOW_DURATION } from 'constants/snackbars/settings';
import prepareGlobalStyles from 'styles/globalStyles';
import resolvedTheme from 'styles/resolvedTheme';
import theme from 'styles/theme';

import 'config/i18n';

axiosSetup();

export const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

ReactDOM.render(
  <StrictMode>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={SHOW_DURATION}
      hideIconVariant
      preventDuplicate
    >
      <QueryClientProvider client={queryClient}>
        <CacheProvider value={muiCache}>
          <BrandContextProvider>
            <ThemeProvider theme={resolvedTheme}>
              <Suspense fallback={<LoaderOverlay />}>
                <GeneralError>
                  <CssBaseline />
                  <GlobalStyles styles={prepareGlobalStyles(theme)} />
                  <App />
                </GeneralError>
              </Suspense>
            </ThemeProvider>
          </BrandContextProvider>
        </CacheProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
